module.exports = __webpack_public_path__ + "img/logo-plants-dummies.82ce09f3.svg";